import React, { useState } from "react";
import styles from "./modal-right.module.css";
import Portrait from "../../portrait/portrait";
import ProfileDescTab from "./profile-desc-tab";
import StatusTab from "./status-tab";
import SkillTab from "./skill-tab";
import { SAVIOR_ATK_TYPE, SAVIOR_ATTRIBUTE, SAVIOR_CLASS, UI_TEXT } from "../../../../constants";
import { getUIText } from "../../../../translation";

export default function ModalRight({ lang, savior }) {
    const [activeTab, setActiveTab] = useState("status");

    const eng = savior.attr.replace("NUAT_", "").toLowerCase();

    return (
        <div className={styles["modal-desc-right"]}>
            <div className={styles["savior-summary"]}>
                <div className={styles["savior-infos"]}>
                    <Portrait lang={lang} savior={savior} />
                    <div className={styles["savior-info"]}>
                        <h2>{savior.name[lang]}</h2>
                        <div className={styles["badges"]}>
                            <span className={`${styles["badge"]} ${styles[eng]} `}>{SAVIOR_ATTRIBUTE[savior.attr][lang]}</span>
                            <span className={styles["badge"]}>{SAVIOR_CLASS[savior.class][lang]}</span>
                            <span className={styles["badge"]}>{SAVIOR_ATK_TYPE[savior.atk_type][lang]}</span>
                        </div>
                    </div>
                </div>
                <p className={styles["savior-desc"]}>{savior.inst.desc[lang]}</p>
            </div>
            <div className={styles["tabs"]}>
                <button
                    className={`${styles["tab-button"]} ${activeTab === "status" ? `${styles["active"]}` : ""}`}
                    onClick={() => setActiveTab("status")}
                >
                    {getUIText(lang, "savior.modal.tab.status")}
                </button>
                <button
                    className={`${styles["tab-button"]} ${activeTab === "skills" ? `${styles["active"]}` : ""}`}
                    onClick={() => setActiveTab("skills")}
                >
                    {getUIText(lang, "savior.modal.tab.skills")}
                </button>
                <button
                    className={`${styles["tab-button"]} ${activeTab === "profile" ? `${styles["active"]}` : ""}`}
                    onClick={() => setActiveTab("profile")}
                >
                    {getUIText(lang, "savior.modal.tab.profile")}
                </button>
            </div>
            {/* status tab */}
            <StatusTab lang={lang} savior={savior} isTabActive={activeTab === "status" ? "active" : ""} />

            {/* skill tab */}
            <SkillTab lang={lang} savior={savior} isTabActive={activeTab === "skills" ? "active" : ""} />

            {/* profile tab */}
            <ProfileDescTab lang={lang} savior={savior} isTabActive={activeTab === "profile" ? "active" : ""} />
        </div>
    );
}
